<div class="main-block">
  <div class="mt-3 mb-4">
    <app-otp-input
      (inputChange)="onOtpChange($event)"
      [config]="otpInputConfig">
    </app-otp-input>
  </div>

  <div *ngIf="errorMessage" class="error-sign text-center mb-30">
    {{ errorMessage }}
  </div>

  <div class="footer-block text-center mb-30">
    <button
      (click)="submitOtpCode(messageResource)"
      [disabled]="errorMessage"
      [ngClass]="confirmButtonClass"
      translate
    >
      label_verify
    </button>
    <div
      class="flex align-items-center justify-content-center mt-10"
      *ngIf="!isResetTimerRunning">

      <span class="footer-label mr-2">Didn’t receive code?</span>
      <a (click)="resendOtpCode()"
        *ngIf="!isResetTimerRunning"
        class="footer-link">
        Resend
      </a>
    </div>
    <div
      class="flex align-items-center justify-content-center mt-10"
      *ngIf="isResetTimerRunning">

      <span class="footer-label mr-2">Resend code in</span>
      <a class="footer-link pointer-events-none">
        0:{{ remainTime() > 9 ? remainTime() : '0' + remainTime() }}
      </a>
    </div>

    <div class="flex align-items-center justify-content-center mt-10 text-nowrap">
      <span class="footer-label mr-2">Need additional help?</span>
      <a
        (click)="openSupportWindow()"
        target="_blank"
        class="footer-link green">
        Contact Support
      </a>
    </div>
  </div>
</div>
